import React, { useEffect, useRef, useState } from 'react';

/**
 * OnFw26Rehber: On'un High5'a gönderdiği "FW26 Run Brand Build · Digital B2B Toolkit"
 * PDF'inin (99 sayfa) özeti — mesaj hiyerarşisi, formatlar, tasarım/kırpma kuralları
 * ve önemli sayfaların görselleri.
 * Route: /r/on-fw26-rehber (ProtectedRoute allowBrandIds High5, sidebar'da VAR)
 *
 * İçerik statik. Yeniden üretmek için: node src/pages/on-fw26-rehber/build.js
 * iframe srcDoc: rapor global seçiciler taşıyor, dashboard stilini bozmasın.
 */
export default function OnFw26Rehber() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./onFw26RehberHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 16));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-2 pb-2">
      {html ? (
        <iframe
          title="On · FW26 B2B Rehberi"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            display: 'block',
            background: '#F6F8FF',
          }}
        />
      ) : (
        <div
          style={{ height, borderRadius: 12, background: '#F6F8FF' }}
          aria-busy="true"
        />
      )}
    </div>
  );
}
